import routes from "routes";
import footerRoutes from "footer.routes";
import DefaultNavbar from "components/Navbars/DefaultNavbar";
import DefaultFooter from "components/Footers/DefaultFooter";
import { useParams } from "react-router-dom";
import MKBox from "components/MKBox";
import CardDetail from "./components/CardDetail";

function PropertyDetails() {
  const { id } = useParams();

  return (
    <>
      <MKBox variant="gradient" style={{ backgroundColor: "#344767" }} shadow="sm" py={0.25}>
        <DefaultNavbar routes={routes} transparent relative light right />
      </MKBox>
      <CardDetail id={id} />
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default PropertyDetails;
